import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import { DriverPermission } from './driverPermissions.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/driverPermissions');

export const getDriverPermissions = actionCreator.async<void, DriverPermission[]>('GET_DRIVER_PERMISSION');
export const updateDriverPermissions = actionCreator.async<void, DriverPermission[]>('UPDATE_DRIVER_PERMISSION');
